import * as React from "react";
import { AdUnitInfoWithLinks, AppState, adUnitInfoSelector } from "@store";
import { Fieldset } from "@components";
import { connect } from "react-redux";
import * as cn from "classnames";

import "./AdUnitInfo.css";

interface AdUnitInfoComponentProps {
    adUnit: AdUnitInfoWithLinks | undefined;
    className?: string;
    selectedFormat?: string;
}

function AdUnitInfoComponent({ adUnit, className, selectedFormat }: AdUnitInfoComponentProps) {
    const isScaled: boolean = selectedFormat === "728x90" || selectedFormat === "768x1024";
    return (
        <div className={cn("AdUnitInfo", className)}>
            <div className={`AdUnitInfo_iframeWrapper AdUnitInfo_iframeWrapper_${selectedFormat}`}>
                <iframe
                    className={cn(`AdUnitInfo_iframe`, className, isScaled ? "AdUnitInfo_iframe_scaled" : "")}
                    src={adUnit ? adUnit.demoUrl : ""}
                />
            </div>
            <div className="AdUnitInfo_col-wrapper">
                <Fieldset className="DemoURL_custom-fieldset" label="AdUnit Demo URL" isMandatory={true}>
                    <input value={adUnit ? adUnit.previewUrl : ""} type="text" readOnly />
                </Fieldset>
                <div>
                    <a href={adUnit ? adUnit.previewUrl : ""} target="_blank">
                        <button
                            className={cn(
                                "common-btn custom-AdUnitInfo-btn",
                                adUnit && adUnit.previewUrl ? "" : "disabled-btn"
                            )}
                            type="button"
                            disabled={adUnit && adUnit.previewUrl ? false : true}
                        >
                            Go to Demo
                        </button>
                    </a>
                </div>
            </div>
        </div>
    );
}

export interface AdUnitInfoProps {
    className?: string;
    selectedFormat?: string;
}

export const AdUnitInfo = connect(
    (appState: AppState, ownProps: AdUnitInfoProps): AdUnitInfoComponentProps => {
        const adUnit = adUnitInfoSelector(appState);

        return {
            adUnit,
            className: ownProps.className,
            selectedFormat: ownProps.selectedFormat
        };
    }
)(AdUnitInfoComponent);
